import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getData } from "../newApis/dotNetApiMethods";
import { message } from "antd";

type TQuery = {
  investRateId: number;
  enteredPrincipalAmount: number;
  tenure: number;
  tenantId: number;
  depositType: any;
};

export const getInvestmentProductRate = async ({
  investRateId,
  enteredPrincipalAmount,
  tenure,
  tenantId,
  depositType,
}: TQuery) => {
  try {
    let queryParam = `?ProductId=${investRateId}&Amount=${enteredPrincipalAmount}&Tenure=${tenure}&TenantId=${tenantId}&depositType=${depositType}`;
    const data = await getData(
      `${ajaxEndpoints.INVESTMENT_PRODUCT_RATE}${queryParam}`,
    );
    return data?.data;
  } catch (error: any) {
    message.error(
      error?.response?.data?.message || "Failed to get investment product rate",
    );
    throw error;
  }
};

export default function useInvestmentProductRate({
  investRateId,
  enteredPrincipalAmount,
  tenure,
  tenantId,
  depositType,
}: TQuery) {
  return useQuery(
    [
      "getInvestmentProductRate",
      {
        investRateId,
        enteredPrincipalAmount,
        tenure,
        tenantId,
        depositType,
      },
    ],
    () =>
      getInvestmentProductRate({
        investRateId,
        enteredPrincipalAmount,
        tenure,
        tenantId,
        depositType,
      }),
    {
      enabled:
        investRateId !== 0 && enteredPrincipalAmount !== 0 && tenure !== 0,
      retry: 0,
      staleTime: 0, // Always fetch fresh data when parameters change
    },
  );
}
